export const rgba = (color, alpha) => {
  const hexToRgb = (hex) => {
    let r = 0,
      g = 0,
      b = 0;

    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return hexToRgb(color);
};

export const LD_CLIENT_IDS = {
  dev: '62dae556f6d14010f57a15d9', // your dev client-side ID
  pie: '62dae556f6d14010f57a15d9', // your pie client-side ID
  stage: '62dae55639dbeb1181277d42', // your staging client-side ID
  prod: '62dae55732beb910ff69aee5' // your production client-side ID
};

export const getEnvironmentFromUrl = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('local-hpsmart')) {
    return 'dev';
  }
  if (hostname.includes('pie')) {
    return 'pie';
  }
  if (hostname.includes('stage')) {
    return 'stage';
  }
  // Default to production
  return 'prod';
};
